<template>
      <list
            :columns="columns"
            :modalCreate="modalCreate"
            :removeLink="removeLink"
            :cardLink="cardLink"
            :isUpdate="true"
            :isAdd="true"
            :itemLink="itemLink"
            :setLink="setLink"
            :openItem="false"
            :fields="fields"
            :searchDisable="true"
            @change="change"
            @changeFunction="changeFunction"
            v-model="val"
      />
</template>
<script>
export default {
  name: "products",
  props:['id'],
  created(){
    this.itemLink = `lessonplans/${this.id}/media`;
    this.setLink = `lessonplans/${this.id}/media`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  
  },
  data() {
    return {
      val: [],
      modalCreate: "client_group",
      fields: [
        {
            col:'col-12 col-md-12',
            key: "files",
            label: "Загрузите  файлы",
            type: "files",
        },

      // {
      //       col:'col-12 col-md-12',
      //       key: "is_time_limit",
      //       label: "Есть лимит времени",
      //       type: "checkbox",
      //  },
      
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_work",
      itemLink: "",
      setLink: "",
      columns: [
          {
            key: "name",
            title: "Название",
            checkbox: false,
          },
          {
            key: "file_name",
            title: "Название файла",
            checkbox: false,
          },
          {
            key: "path",

          },

             {
            key: "created_at",
            dateTimeFormat:true
          },
       
          {
          //     detail: true,
              remove: true,
          },
      ],
    };
  },
};
</script>
<style>
</style>
